import _ from 'lodash';
import CacheableDataObject from './CacheableDataObject';
import Category from "./Category.jsx";

export default class CategoryGroup extends CacheableDataObject {
	beforeConstruct() {
		this.instanceNumber = --CategoryGroup.instanceCount;
		this.deleteEdit = null;
		this.name = '';
		this.type = null;
		this.id = null;

		this.categories = new Map();
	}


	clone() {
		const categoryGroup = CategoryGroup.create();
		categoryGroup.id = this.id;
		categoryGroup.name = this.name;
		categoryGroup.type = this.type;
		categoryGroup.categories = this.categories;
		categoryGroup.original = this;
		return categoryGroup;
	}


	setCategories(categoryArray) {
		this.categories = new Map();
		for(let category of categoryArray) {
			this.addCategory(category);
		}
		console.log('the array received', [...categoryArray]);
		console.log('set caregories to ', [...this.categories]);
		this.sortCategories();
		console.log('end result', this.categories);
	}

	sortCategories() {
		if(this.isSorted()) {
			return;
		}
		const parents = new Map();
		const children = new Map();
		for(let [key, category] of this.categories) {
			if(!category.parent_category_id) {
				parents.set(category.id, category);
			}
			else {
				if(!children.has(category.parent_category_id)) {
					children.set(category.parent_category_id, []);
				}
				children.get(category.parent_category_id).push(category);
			}
		}
		this.categories = new Map();

		parents.forEach((parent) => {
			this.categories.set(parent.id, parent);
			if(children.has(parent.id)) {
				_.each(children.get(parent.id), (child) => {
					this.categories.set(child.id, child);
					parent.addChildCategory(child);
					child.addParentCategory(parent);
				});

				children.delete(parent.id);
			}
		});
		children.forEach((childGroup) => {
			for(let child of childGroup) {
				this.categories.set(child.id, child);
			}
		});
	}

	isSorted() {
		let isSorted = true;
		let lastParent = null;
		for(let [key, category] of this.categories) {
			if(!category.parent_category_id) {
				lastParent = category;
				continue;
			}
			if(!lastParent) {
				return false;
			}
			if(category.parent_category_id) {
				if(lastParent.id !== category.parent_category_id) {
					isSorted = false;
				}
				else {
					lastParent.addChildCategory(category);
					category.addParentCategory(lastParent);
				}
			}
		}
		return isSorted;
	}

	resetCategories() {
		this.categories.clear();
	}

	isExpenseCategoryGroup() {
		return (this.type === Category.types.EXPENSE || this.isLoanCategoryGroup());
	}

	isIncomeCategoryGroup() {
		return this.type === Category.types.INCOME;
	}

	isLoanCategoryGroup() {
		return this.type === Category.types.LOANS;
	}

	addCategory(category) {
		this.categories.set(category.id, category);
	}

	getCategories() {
		return Array.from(this.categories).map(([key, category]) => {
			return category;
		});
	}

	getVisibleCategoryForMonths(selectedMonths, includeCategoriesWitHNoActivity = false) {
		const categories = this.getCategories();
		return categories.filter((category) => {
			const budget = category.getMultiBudget(selectedMonths);
			if(includeCategoriesWitHNoActivity && !category.show_when_not_used && !budget.hasActivity()) {
				return false;
			}
			if(!category.deleted) {
				return true;
			}
			if(budget.hasActivity()) {
				return true;
			}
			return false;
		});
	}
}
CategoryGroup.instanceCount = -1;
CategoryGroup.prototype.dataLocationParsers = {
	name: (categoryGroup, data) => {
		categoryGroup.name = data.name;
	}
};